import React from 'react';
import { initializeAuth } from '../utils/api';

enum InitializationStatus {
    Failure = 0,
    Success = 1,
}

interface PropsType {
  children: JSX.Element
}

interface StateType {
  authInitialized: boolean;
  authError: string | null;
}

/**
  * Application initialization wrapper that handles Katal authentication setup.
  *
  * This component manages the application initialization including:
  * - Katal authentication initialization
  * - Component initialization metrics
  * - Error handling and recovery
  */
export class AppInitWrapper extends React.Component<PropsType, StateType> {
    constructor(props: PropsType) {
        super(props);
        this.state = {
            authInitialized: false,
            authError: null,
        };
    }

    async componentDidMount() {
        try {
            // Initialize authentication system (Katal or Midway)
            await initializeAuth();
            
            this.setState({ 
                authInitialized: true,
                authError: null 
            });
            
            // Publish component initialization metrics
            console.log('Application initialized successfully');
        } catch (error) {
            console.error('Application initialization failed:', error);
            this.setState({ 
                authInitialized: true, // Continue even if auth fails
                authError: error instanceof Error ? error.message : 'Unknown error'
            });
        }
    }

    componentDidCatch(error: Error, info: React.ErrorInfo) {
        console.error('Application error caught:', error, info);
        // In your application you may want to update the UI; here we will re-throw and fail the whole app, after logging
        throw error;
    }

    render() {
        const { authInitialized, authError } = this.state;
        
        // Show loading state while initializing
        if (!authInitialized) {
            return (
                <div style={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    height: '100vh',
                    fontFamily: 'Arial, sans-serif'
                }}>
                    <div>
                        <div>Initializing application...</div>
                        {authError && (
                            <div style={{ color: 'orange', marginTop: '10px', fontSize: '14px' }}>
                                Warning: {authError}
                            </div>
                        )}
                    </div>
                </div>
            );
        }
        
        return this.props.children;
    }
}

export default AppInitWrapper;
